 <template>
    <v-card class="py-0 my-0" color="transparent">
        <v-card-title class='py-0 my-0'>
            <!--<code>{{ itemid }}</code>-->
                       
            <v-spacer></v-spacer>
            <v-btn
                fab                
                small
                v-on:click="onDialogToggled()"
                v-if="attributes.withdialog"
                >
                <v-icon>
                    add
                </v-icon>
            </v-btn>
            <v-text-field
                v-if="attributes.withsearch"
                v-model="search"
                append-icon="search"
                label="Search"
                single-line
                hide-details
                solo                
            ></v-text-field>
        </v-card-title>
        <v-data-table
            :headers="attributes.headers"
            :items="items"
            :search="search"
            v-model="result"
            :select-all="attributes.withcheck"
            item-key="id"     
            class='py-0 my-0'
        >
            <template slot="items" slot-scope="props">
                <td v-if="attributes.withcheck">
                    <v-checkbox
                        v-model="props.selected"
                        primary
                        hide-details
                    ></v-checkbox>
                </td>
                <td v-for="header in attributes.headers">
                    <span>{{display(props.item,header.value)}}</span>
                </td>
                
                <td class="justify-center">
                    <v-icon
                        small
                        class="mr-2"
                        v-on:click="editItem(props.item.id)"
                    >
                      edit
                    </v-icon>
                    <v-icon
                      small
                      v-on:click="deleteItem(props.item.id)"
                    >
                      delete
                    </v-icon>
                  </td>
            </template>
            <v-alert v-if="attributes.withsearch" slot="no-results" :value="true" color="error" icon="warning">
                Your search for "{{ search }}" found no results.
            </v-alert>            
        </v-data-table>        
        <formdatatabledialog                    
                    :dialog="dialog"                     
                    :formdata="itemsformdata" 
                    :itemid="itemid"
                    v-on:dialogtoggled="onDialogToggled()"
                    >                        
        </formdatatabledialog>
    </v-card>
</template>


<script>
import formdatatabledialog from "./MainDialog.vue"
export default {
    components: {
        formdatatabledialog: formdatatabledialog
    },
    props:[
        'attributes',
        'vuexnamespace',            
    ],
    methods: {
        async editItem (item) {          
            
            this.itemid=item
            await this.$store.dispatch(this.itemsnamespace +'/getById',item)
            this.dialog = true
        },

        deleteItem (item) {
            
            this.itemid=item            
            confirm('Are you sure you want to delete this item?') && 
                        this.$store.dispatch(this.itemsnamespace +'/deleteById',this.itemid)
            
        },
        
        onDialogToggled() {   
            //console.log(this.dialog)            
            this.dialog = !this.dialog
            this.itemid=undefined
            
        },
        display(item, variable) {
            let result = item[variable].toString()
            if(typeof item[variable] === 'object') {
                if(item[variable].length) {
                    result = item[variable].map(x=>x.name).join(',')
                }
                
            }
            return result
        }
        
        
    },
   
    computed: {
        
        itemsnamespace (){return this.attributes.items.split('/')[0]},
        itemsformdata (){return this.$store.getters[this.itemsnamespace + '/formdata']},
        items () {return this.$store.getters[this.attributes.items]}, 
        rowsrc () {return this.$store.getters[this.itemsnamespace + '/dataobject']},        
        parent_id () {return this.$route.params.id},
        canedit () {return typeof this.parent_id != "undefined"},
        result() {return this.$store.getters[this.vuexnamespace + '/data'](this.attributes.variable)},
        
        
    },
    
    data () {
        return {            
            search: '',
            withsearch:false,
            withcheck:false,            
            dialog: false,
            formdatatabledialog: formdatatabledialog,            
            itemid:undefined,
            
        }   
    },
    /*
    updated() {           
        this.result = this.$store.getters[this.vuexnamespace + '/data'](this.attributes.variable)        
    }
    */
}
</script>